import moment from "moment";
import { Dropdown } from "react-bootstrap";
import {
  CONTRACT_STATUS_DESC,
  CONTRACT_TYPE_DESCRIPTIONS,
  ADDON_TYPE_DESC,
} from "../../../../constants/Contract";
import "../../../../assets/stylesheets/HomePage/HomePagePriorApps.scss";
import CustomDropdown from "../../../SharedComponents/CustomDropdown";
import { Button } from "react-blueprint-library";
import { buildAddOnText } from "../../../../common/Functions";
import { useState, useEffect } from "react";
import { getAddonStatus } from "../../../../api/makeAPIRequest";

const HomePagePriorApps = ({
  agencynumber,
  applicationStatus,
  contracttype,
  contractid,
  contracteffectivedate,
  mmlis,
  finance,
  cmid,
  lastchangedate,
  mmlisregistrationdate,
  contract,
  setContractData,
  isPriorContract,
  cria,
  ia,
  oktasubid,
}) => {
  const [addonStatus, setAddonStatus] = useState(null);

  // Fetch addon status when component mounts if there are addons
  useEffect(() => {
    const fetchAddonStatus = async () => {
      if ((mmlis || finance || cria || ia) && oktasubid && contractid) {
        try {
          const status = await getAddonStatus(oktasubid, contractid);
          setAddonStatus(status);
        } catch (error) {
          console.error("Error fetching addon status:", error);
        }
      }
    };

    fetchAddonStatus();
  }, [mmlis, finance, cria, ia, oktasubid, contractid]);

  const showArchiveDeclineMessage =
    applicationStatus === CONTRACT_STATUS_DESC.DECLINED_BY_HOME_OFFICE ||
    applicationStatus === CONTRACT_STATUS_DESC.ACKNOWLEDGED_DECLINED ||
    applicationStatus === CONTRACT_STATUS_DESC.ARCHIVE_DECLINED_BY_AGENCY ||
    applicationStatus === CONTRACT_STATUS_DESC.ARCHIVE_APPLICATION_WITHDRAWN;
  const showAddons = mmlis || finance || cria || ia;

  const addOns = buildAddOnText({ mmlis, financingonly: finance, cria, ia });

  const effectiveDate =
    contracttype === CONTRACT_TYPE_DESCRIPTIONS.MMLIS ||
    contracttype === CONTRACT_TYPE_DESCRIPTIONS.CRIA_ONLY ||
    contracttype === CONTRACT_TYPE_DESCRIPTIONS.INVESTMENT_ADVISOR
      ? moment.utc(mmlisregistrationdate).format("MMMM DD, YYYY")
      : moment.utc(contracteffectivedate).format("MMMM DD, YYYY");

  const isCorpContract =
    contracttype === CONTRACT_TYPE_DESCRIPTIONS.BROKER_CORP ||
    contracttype === CONTRACT_TYPE_DESCRIPTIONS.MEMBER_CORP;

  const priorAppDetailsLayout = showArchiveDeclineMessage
    ? isCorpContract
      ? "archive-decline-broker-corp-layout"
      : "archive-decline-regular-layout"
    : isCorpContract
      ? "broker-corporation-layout"
      : "regular-layout";

  const cmidLabel = isCorpContract ? "Member CMID" : "CMID";

  return (
    <div id={`priorApp${contractid}`} className="home-page-prior-apps">
      <div className="container">
        <div className="row">
          <div className="col-lg-4 col-sm-12">
            <h3>
              {showArchiveDeclineMessage && (
                <span className="badge badge-indicator"></span>
              )}
              {contracttype}
            </h3>
            {showAddons && (
              <div style={{ display: "inline-block" }}>{addOns}</div>
            )}
            {contracttype !== CONTRACT_TYPE_DESCRIPTIONS.MMLIS && cmid && (
              <div>
                {cmidLabel} {cmid !== null ? cmid : "##########"}
              </div>
            )}

            {/* Display Addon Status unless contract is Declined by Home Office */}
            {applicationStatus !== CONTRACT_STATUS_DESC.DECLINED_BY_HOME_OFFICE &&
              addonStatus &&
              Array.isArray(addonStatus) &&
              addonStatus.length > 0 && (
                <div
                  className="addon-status-display"
                  style={{ marginTop: "12px" }}
                >
                  {addonStatus.map((addon) => {
                    const normalizedDesc = addon.addontypedesc?.trim().toLowerCase();
                    const addonLabel =
                      normalizedDesc === ADDON_TYPE_DESC.CRIA_DESIGNATION.toLowerCase()
                        ? ADDON_TYPE_DESC.CRIA_REGISTRATION
                        : normalizedDesc === ADDON_TYPE_DESC.IA_DESIGNATION.toLowerCase()
                          ? ADDON_TYPE_DESC.IA_REGISTRATION
                          : addon.addontypedesc;
                    return (
                      <div
                        key={addon.contractaddonstatusid}
                        className="addon-status-item"
                      >
                        <strong>{addonLabel}:</strong>{" "}
                        <span className="status-inactive">
                          {addon.contractstatusdesc}
                        </span>
                      </div>
                    );
                  })}
                </div>
              )}
          </div>
          {showArchiveDeclineMessage ? (
            <>
              <div
                className={`${
                  isCorpContract ? "col-lg-4" : "col-lg-7"
                } col-sm-12`}
              >
                <p className="archive-message">
                  <div>
                    Your agency licensing coordinator in Agency #{agencynumber}{" "}
                    will contact you with more information.
                  </div>
                  <div>
                    As of {moment(lastchangedate).utc().format("MMMM DD, YYYY")}
                  </div>
                </p>
              </div>

              {isCorpContract && (
                <div className="col-lg-3 col-sm-12">
                  <p>
                    <div className="corporation-information">
                      <div className="corporation-name">
                        {contract?.corpname}
                      </div>
                      {contract?.corpmmid && (
                        <div className="corporation-mmid">
                          Corporation MMID {contract?.corpmmid}
                        </div>
                      )}
                      {contract?.corpcmid && (
                        <div className="corporation-cmid">
                          Corporation CMID {contract?.corpcmid}
                        </div>
                      )}
                    </div>
                  </p>
                </div>
              )}
            </>
          ) : (
            <>
              <div className={`col-lg-2 col-sm-12`}>
                <p>
                  <div className="agency-number">
                    <div>Agency #{agencynumber}</div>
                  </div>
                </p>
              </div>
              <div
                className={`${
                  isCorpContract ? "col-lg-2" : "col-lg-5"
                } col-sm-12`}
              >
                <p>
                  <div className="effective-date">
                    <div>Effective {effectiveDate}</div>
                  </div>
                </p>
              </div>
              {isCorpContract && (
                <div className={`col-lg-3 col-sm-12`}>
                  <p>
                    <div className="corporation-information">
                      <>
                        <div className="corporation-name">
                          {contract?.corpname}
                        </div>
                        {contract?.corpmmid && (
                          <div className="corporation-mmid">
                            Corporation MMID {contract?.corpmmid}
                          </div>
                        )}

                        {contract?.corpcmid && (
                          <div className="corporation-cmid">
                            Corporation CMID {contract?.corpcmid}
                          </div>
                        )}
                      </>
                    </div>
                  </p>
                </div>
              )}
            </>
          )}

          <div className={`col-lg-1 col-sm-12 ${priorAppDetailsLayout}`}>
            <div className="prior-apps-dropdown-wrapper">
              <div className="mobile-documents-btn-wrapper">
                <Button
                  variant={"secondary"}
                  onClick={() => {
                    setContractData({
                      contractid,
                      mmlis,
                      ia,
                      applicationStatus,
                      contracttypedesc: contracttype,
                      isPriorContract,
                    });
                  }}
                >
                  Documents
                </Button>
              </div>
              <CustomDropdown id={`quickActions${contractid}`}>
                <Dropdown.Item
                  onClick={() => {
                    setContractData({
                      contractid,
                      mmlis,
                      ia,
                      applicationStatus,
                      contracttypedesc: contracttype,
                      isPriorContract,
                    });
                  }}
                >
                  Documents
                </Dropdown.Item>
              </CustomDropdown>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomePagePriorApps;
